// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3MwI4","content":"GlobalSearch_content__3d4lE"};